module.exports = __webpack_public_path__ + "img/angle_right.1dad4fc5.svg";